let $floatingIcon: HTMLElement | null = null;

// when an element on the page is visible inside the viewport, hide the floating icon.
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      $floatingIcon?.classList.add("hidden");
    } else {
      $floatingIcon?.classList.remove("hidden");
    }
  });
});

let bodyHeight = document.body.scrollHeight;

document.addEventListener("DOMContentLoaded", function () {
  $floatingIcon = document.querySelector(".section-floating-icon")!;
  const $footerSection = document.querySelector(".shopify-section-group-footer-group");
  if ($footerSection && $floatingIcon) {
    // change the element selector based on requirements, this should typically be the footer section element
    observer.observe($footerSection);
  }

  bodyHeight = document.body.scrollHeight;
});

// spin the floating icon!
document.addEventListener("scroll", () => {
  if  (!$floatingIcon) return;
  const deg = Math.round(window.scrollY / bodyHeight * 360)
  $floatingIcon.style.transform = `rotate(${deg}deg)`;
}, { passive: true });
